import { NgModule } from '@angular/core';
import { SitemuleDownloadComponent } from './download.component';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ContainerModule } from '@sitemule/ng-components/components/container';
import { ContactFormModule } from 'src/app/shared/components/contact-form/contact-form.module';
import { Frame3Module } from 'src/app/app-frames/frame-3/frame-3.module';
import { PersonsModule } from 'src/app/shared/components/persons-contact/team.module';
import { SvgIconModule } from '@sitemule/ng-components/directives/svg-icon';
import { YoutubeModalModule } from 'src/app/components/youtube-modal/youtube-modal.module';
import { ImageAnimationModule } from 'src/app/shared/components/image-animation/image-animation.module';
import { TechnicalModule } from 'src/app/components/technical/technical.module';

const routes: Routes = [
  {
    path: '',
    component: SitemuleDownloadComponent,
  },
];

@NgModule({
  declarations: [SitemuleDownloadComponent],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    Frame3Module,
    ContainerModule,
    PersonsModule,
    SvgIconModule,
    YoutubeModalModule,
    ImageAnimationModule,
    ContactFormModule,
  ],
})
export class SitemuleDownloadModule {}
